var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21376 0.817281C4.86528 2.37518 1.50581 5.96515 0.337295 10.3024C-0.396324 13.0259 0.0993519 17.0772 1.50769 19.8689C5.80057 28.3772 17.4051 29.6639 23.6595 22.325C26.3438 19.1751 26.7872 17.1582 26.7872 8.09567V0.134873L18.895 0.155695C13.4991 0.169892 10.4369 0.379063 9.21376 0.817281ZM29.6142 13.3183V26.6362H42.8071H56L55.9929 25.0981C55.9722 20.4647 53.0217 13.289 49.3889 9.03552C45.531 4.51894 38.592 0.942689 32.4318 0.295773L29.6142 0V13.3183ZM8.59275 30.714C5.88067 31.6804 2.94572 34.3537 1.45162 37.2187C0.386769 39.2617 0.18275 40.255 0.17474 43.4361C0.16673 46.7539 0.337766 47.5338 1.55764 49.7457C3.08095 52.5076 4.6787 54.0527 7.64993 55.6361C10.4101 57.1079 16.3073 57.1079 19.0674 55.6361C22.0387 54.0527 23.6364 52.5076 25.1597 49.7457C26.5374 47.2475 26.553 47.1349 26.7066 38.5854L26.8621 29.9488L18.6966 29.9862C12.8215 30.0132 9.9879 30.2171 8.59275 30.714ZM29.6863 38.3488C29.8366 46.0668 29.9412 46.9352 30.9768 49.0477C32.3367 51.8223 34.5992 54.179 37.2835 55.6167C39.0914 56.5854 40.0366 56.6971 47.6366 56.8415L56 57V43.4744V29.9488H42.7614H29.5228L29.6863 38.3488Z",
    fill: "#E02829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5fc5c1e7da3a7ecad7f422088f94d5ed.svg";
export { ForwardRef as ReactComponent };